{
  "gimbalDeg": 3,
  "aimAssist": {
    "coneDeg": 9,
    "gimbalDeg": 7,
    "fullWithin": 0.35,
    "levels": {
      "off": 0,
      "low": 0.5,
      "standard": 1,
      "high": 1.35
    },
    "aiLevel": "standard"
  },
  "pools": {
    "projectiles": 2048,
    "torpedoes": 64
  },
  "batteries": { "playerBatteries": false },
  "weapons": [
    {
      "id": "pdc",
      "kind": "projectile",
      "name": "PDC autocannon",
      "rate": 12,
      "speed": 1200,
      "range": 2000,
      "damage": 6,
      "vsShield": 0.5,
      "vsHull": 1.5,
      "energyCost": 0,
      "spreadDeg": 0.15,
      "tracerEvery": 3,
      "vfx": {
        "muzzle": "muzzlePdc",
        "impact": "hitHull",
        "shieldImpact": "hitShield"
      },
      "sfx": "pdc"
    },
    {
      "id": "pulseLaser",
      "kind": "projectile",
      "name": "Pulse laser",
      "rate": 4,
      "speed": 2500,
      "range": 2500,
      "damage": 14,
      "vsShield": 1.5,
      "vsHull": 0.5,
      "energyCost": 5,
      "spreadDeg": 0,
      "tracerEvery": 1,
      "vfx": {
        "muzzle": "muzzleLaser",
        "impact": "hitHull",
        "shieldImpact": "hitShield"
      },
      "sfx": "laser"
    },
    {
      "id": "torpedo",
      "kind": "torpedo",
      "name": "Homing torpedo",
      "rate": 0.6666666666666666,
      "speed": 400,
      "turnRateDeg": 90,
      "lifeSeconds": 12,
      "damage": 120,
      "vsShield": 1,
      "vsHull": 1,
      "energyCost": 0,
      "rounds": 8,
      "proximity": 15,
      "lock": {
        "range": 3000,
        "coneDeg": 15,
        "seconds": 2
      },
      "vfx": {
        "muzzle": "torpedoLaunch",
        "impact": "explosionSmall",
        "shieldImpact": "explosionSmall",
        "trail": "torpedoTrail"
      },
      "sfx": "torpedo"
    },
    {
      "id": "pdcTurret",
      "kind": "projectile",
      "name": "PDC turret",
      "rate": 15,
      "speed": 1400,
      "range": 1500,
      "damage": 3,
      "vsShield": 0.5,
      "vsHull": 1.5,
      "energyCost": 0,
      "spreadDeg": 0.4,
      "tracerEvery": 3,
      "turret": {
        "traverseDeg": 180,
        "arcDeg": 110,
        "fireConeDeg": 3,
        "prefer": "torpedo",
        "interceptRadius": 3,
        "clearance": 10
      },
      "vfx": {
        "muzzle": "muzzlePdc",
        "impact": "hitHull",
        "shieldImpact": "hitShield"
      },
      "sfx": "pdc"
    },
    {
      "id": "flakTurret",
      "kind": "projectile",
      "name": "Flak turret",
      "rate": 3,
      "speed": 900,
      "range": 900,
      "damage": 8,
      "vsShield": 1,
      "vsHull": 1,
      "energyCost": 0,
      "spreadDeg": 1.2,
      "tracerEvery": 1,
      "turret": {
        "traverseDeg": 90,
        "arcDeg": 100,
        "fireConeDeg": 4,
        "prefer": "ship",
        "interceptRadius": 0,
        "clearance": 15
      },
      "vfx": {
        "muzzle": "muzzlePdc",
        "impact": "hitHull",
        "shieldImpact": "hitShield"
      },
      "sfx": "pdc"
    }
  ]
}
